import styled from 'styled-components';

export const Thumbnail = styled.figure<{ isChildren?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 64px;
	height: 64px;

	img {
		max-width: 64px;
		max-height: 64px;
	}
`;
